// Shared utilities for working with analyses

export type GenericAnalysis = {
  analysis_type?: string;
  analyzed_at?: string;
  created_at?: string;
  [key: string]: any;
};

// Returns the latest analysis of a given type.
// Prefer analyzed_at, fall back to created_at. Ignores items without timestamp.
export const getLatestAnalysis = <T extends GenericAnalysis>(
  analyses: T[] | undefined | null,
  analysisType: string
): T | null => {
  if (!Array.isArray(analyses) || analyses.length === 0) return null;

  const filtered = analyses.filter(a => a && a.analysis_type === analysisType);
  if (filtered.length === 0) return null;

  const sortable = filtered
    .map(a => ({
      item: a,
      ts:
        (a.analyzed_at ? Date.parse(a.analyzed_at) : NaN) ||
        (a.created_at ? Date.parse(a.created_at) : NaN)
    }))
    .filter(x => Number.isFinite(x.ts));

  if (sortable.length === 0) return filtered[0] || null;

  sortable.sort((a, b) => b.ts - a.ts);
  return sortable[0].item;
};


